import { globals } from '@/src/globals'

export const renderNewGallery = (data: any) : string => {
  const title = data.title.rendered
  const description = data.acf.wysiwyg_galleryContent

  let imageList = ''

  if (data.acf.gallery_gallery) {
    data.acf.gallery_gallery.forEach(image => {
      const url = image.url
      let miniatureURL = ''

      if (image.width === 400 && image.height === 300) {
        miniatureURL = url
      } else {
        miniatureURL = url as string
        miniatureURL = miniatureURL.replace('.jpg', '-400x300.jpg')
      }

      imageList += /* html */ `
      <div class="col-3 galleryList__singleGalleryImage">
        <a href="${url}" class="js-galleryTrigger">
          <img src="${miniatureURL}">
        </a>
      </div>
    `
    })
  }

  return /* html */ `
  <div class="galleryList__single js-singleGallery">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 galleryList__singleTextContent">
          <h2 class="galleryList__singleTitle">
            ${title}
          </h2>
          ${(description) ? /* html */`
            <div class="galleryList__singleDescription">
              ${description}
            </div>
          ` : ''}           
        </div>
      </div>

      <div class="row galleryList__singleGalleryWrapper">
        ${imageList}
      </div>
    </div>

  </div>
`
}
